import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-48e073be"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "nav-margin"
}, null, -1));
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = {
  class: "highlignt"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_cell = _resolveComponent("van-cell");
  const _component_ListViewCpt = _resolveComponent("ListViewCpt");
  const _component_PageNavBackLayoutCpt = _resolveComponent("PageNavBackLayoutCpt");
  return _openBlock(), _createBlock(_component_PageNavBackLayoutCpt, {
    class: "page"
  }, {
    default: _withCtx(() => [_createVNode(_component_ListViewCpt, {
      ref: "ListViewCpt",
      request: $data.listRequest
    }, {
      default: _withCtx(({
        item
      }) => [_hoisted_1, _createVNode(_component_van_cell, {
        "arrow-direction": "",
        "is-link": "",
        onClick: $event => $options.alertWindow(item),
        to: '/work-wx/appoint/application/detail?item=' + JSON.stringify({
          productId: item.productId,
          productName: item.productName,
          foundDate: item.foundDate,
          openDate: item.openDate,
          raiseEndDate: item.raiseEndDate,
          raiseStartDate: item.raiseStartDate,
          riskGrade: item.riskGrade
        }),
        title: item.productName
      }, {
        label: _withCtx(() => [item.openDate ? (_openBlock(), _createElementBlock("div", _hoisted_2, "开放日: " + _toDisplayString(item.openDate), 1)) : _createCommentVNode("", true), _createElementVNode("div", null, [_createTextVNode(" 剩余额度: "), _createElementVNode("span", _hoisted_3, _toDisplayString(item.leftRaiseScale), 1), _createTextVNode(" 元 ")]), _createElementVNode("div", null, "募集开始时间: " + _toDisplayString(item.raiseStartDate), 1), _createElementVNode("div", null, "募集结束时间: " + _toDisplayString(item.raiseEndDate), 1)]),
        _: 2
      }, 1032, ["onClick", "to", "title"])]),
      _: 1
    }, 8, ["request"])]),
    _: 1
  });
}